import { IconProps } from "../IconProps";

export const IconHeart16 = ({ className, color = "#FFF" }: IconProps) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00001 3.47943C6.60047 1.90357 4.26182 1.41656 2.50829 2.85958C0.75475 4.30259 0.507876 6.71523 1.88494 8.42191C3.02988 9.84085 6.49485 12.8336 7.63048 13.8023C7.75749 13.9106 7.82104 13.9648 7.89516 13.9861C7.95979 14.0046 8.03057 14.0046 8.09528 13.9861C8.16941 13.9648 8.23287 13.9106 8.35996 13.8023C9.4956 12.8336 12.9605 9.84085 14.1055 8.42191C15.4825 6.71523 15.2658 4.28741 13.4821 2.85958C11.6984 1.43174 9.39954 1.90357 8.00001 3.47943Z"
      />
    </svg>
  );
};
